<template>

    <body class="dx-viewport">
        <DxDataGrid ref="dataGridRef" :allowColumnReordering="true" :data-source="dsDrepturiCustom"
            :allowColumnResizing="true" key-expr="ID" :columnAutoWidth="false" :columnMinWidth="50"
            :columnResizingMode="'nextColumn'" :show-borders="true" :syncLookupFilterValues="false"
            :filter-sync-enabled="true" show-row-lines="true" row-alternation-enabled="true" show-column-lines="false"
            @selection-changed="onSelectionChanged" @row-inserting="onRowInserting" @row-removing="onRowRemoving"
            @row-updating="onRowUpdating"
            class="border">
            <DxSelection mode="single" />
            <DxFilterRow :visible="true" />
            <DxPaging :page-size="5" :page-index="1" />
            <DxLoadPanel :enabled="true" :indicator-src="'reload6.gif'" />
            <DxSorting mode="multiple" />
            <DxStateStoring :enabled="true" :filterValue="false" storage-key="Drepturi" />
            <DxEditing
                :allow-updating="true"
                :allow-deleting="true"
                mode="row"
                :texts="{ confirmDeleteMessage: deleteConfirmationMessage, confirmDeleteTitle: 'Confirmare Ștergere', saveRowChanges: 'Salvează', cancelRowChanges: 'Anulează' }"
            />
            <DxToolbar>
                <DxItem>
                    <template #default>
                        <DxButton icon="add" type="success" @click="onAddClick" />
                    </template>
                </DxItem>
                <DxItem>
                    <template #default>
                        <DxButton icon="refresh" @click="onRefreshClick" />
                    </template>
                </DxItem>
            </DxToolbar>
            <DxColumn data-field="Nume" :allow-editing="false" />
            <DxColumn data-field="Cod" :allow-editing="false" />
            <DxColumn data-field="Explicatie" :allow-editing="false" />
            <DxColumn data-field="ModulID" caption="Modul">
                <DxLookup :data-source="dsModule" value-expr="ID" display-expr="Nume" />
            </DxColumn>
            <DxColumn data-field="Meniu" :visible="false" />
        </DxDataGrid>
        <DxPopupAdd :visible.sync="isModalVisible" :closeOnOutsideClick="false" :showCloseButton="false"
            :showTitle="true" :width="550" :height="480">
            <template #title>
                <div
                    style="background-color: #ff2c21; font-size: 15px; color: white; font-weight: bold;  padding: 10px; padding-left: 20px; ">
                    Adăugare
                </div>
            </template>
            <div>
                <DxForm :formData="formData">
                    <DxItem :col-span="1" :col-count="1" item-type="group">
                        <DxItem data-field="Nume" :editor-options="{ width: 510 }">
                            <DxValidationRule>
                                <DxRequiredRule />
                            </DxValidationRule>
                        </DxItem>
                        <DxItem data-field="Cod" :editor-options="{ width: 510 }">
                            <DxValidationRule>
                                <DxRequiredRule />
                            </DxValidationRule>
                        </DxItem>
                        <DxItem data-field="Explicatie" :editor-options="{ width: 510, height: 120 }" />
                        <DxItem data-field="ModulID" editor-type="dxSelectBox"
                            :editor-options="{ dataSource: dsModule, valueExpr: 'ID', displayExpr: 'Nume', width: 510, showClearButton: true, placeholder: 'Selectați modulul...' }">
                            <DxValidationRule>
                                <DxRequiredRule message="Câmpul Modul este obligatoriu!" />
                            </DxValidationRule>
                        </DxItem>
                        <DxItem data-field="Meniu" :visible="false" />

                    </DxItem>
                </DxForm>
                <div style="display: flex; justify-content: flex-end; gap: 8px;">
                    <DxButton text="Salvează" type="success" width="100" @click="onSaveAdd" />
                    <DxButton text="Închide" type="danger" width="100" @click="onCancel" />
                </div>
            </div>
        </DxPopupAdd>
    </body>
</template>
<script lang="ts">
import { defineComponent, ref } from 'vue';
import { DxButton } from 'devextreme-vue/button';
import DxPopupAdd, { DxToolbarItem } from 'devextreme-vue/popup';
import { DxItem, DxForm, DxLabel } from 'devextreme-vue/form';
import {
    DxColumn,
    DxDataGrid,
    DxEditing,
    DxFilterRow,
    DxLoadPanel,
    DxPaging,
    DxSelection,
    DxSorting,
    DxStateStoring,
    DxToolbar,
    DxPopup,
    DxItem as DxItemForm,
    DxForm as DxFormGrid,
    DxValidationRule,
    DxRequiredRule,
    DxLookup,
} from 'devextreme-vue/data-grid';
import 'devextreme/dist/css/dx.light.css';
import 'devextreme/dist/css/dx.common.css';
import notify from 'devextreme/ui/notify';
import { locale, loadMessages } from 'devextreme/localization';
import ResponseData from '@/types/responseData';
import AUTH_DrepturiCustom from '@/services/AUTH/AUTH_DrepturiCustom';
import AUTH_DrepturiModule from '@/services/AUTH/AUTH_DrepturiModule';
import DrepturiCustom from '@/types/auth/drepturiCustom';

export default defineComponent({
    components: {
        DxToolbar,
        DxDataGrid,
        DxEditing,
        DxColumn,
        DxSorting,
        DxSelection,
        DxFilterRow,
        DxStateStoring,
        DxLoadPanel,
        DxPaging,
        DxButton,
        DxItem,
        DxPopup,
        DxForm,
        DxLabel,
        DxPopupAdd,
        DxToolbarItem,
        DxItemForm,
        DxFormGrid,
        DxValidationRule,
        DxRequiredRule,
        DxLookup,
    },
    data() {
        return {
            dsDrepturiCustom: [] as DrepturiCustom[],
            dsModule: [] as any[],
            isModalVisible: false,
            formData: {
                Nume: '',
                Cod: '',
                Explicatie: '',
                ModulID: null as string | null,
                Meniu: false
            },
            deleteConfirmationMessage: "Sigur doriți să ștergeți această înregistrare?",
            dataGridRef: ref<DxDataGrid | null>(null),

        };
    },
    methods: {
        loadModules() {
            AUTH_DrepturiModule.getModule()
                .then((r: any) => { this.dsModule = r.data ?? []; })
                .catch(console.error);
        },
        getDrepturiCustom() {
            AUTH_DrepturiCustom.get()
                .then((response: ResponseData) => {
                    this.dsDrepturiCustom = response.data.filter((item: any) => item.Meniu === false || item.Meniu === 0);
                })
                .catch((e: Error) => {
                    console.log(e)
                });
        },
        onSelectionChanged(e: any) {
            const selectedRow = e.selectedRowsData[0];
            this.$emit('selection-changed', selectedRow.ID);
        },
        onAddClick() {
            this.isModalVisible = true;
        },
        onSaveAdd() {
            if (!this.formData.Nume || this.formData.Nume.trim() === '') {
                notify('Completați câmpul obligatoriu "Nume"!', 'error', 1000);
                return;
            }
            if (!this.formData.Cod || this.formData.Cod.trim() === '') {
                notify('Completați câmpul obligatoriu "Cod"!', 'error', 1000);
                return;
            }
            if (!this.formData.ModulID) {
                notify('Completați câmpul obligatoriu "Modul"!', 'error', 1000);
                return;
            }

            const savePromise = this.$refs.dataGridRef?.instance?.saveEditData();
            console.log(this.formData);
            const body = this.formData;
            AUTH_DrepturiCustom.save(body)
                .then((response) => {
                    this.isModalVisible = false;
                    notify('Datele au fost salvate cu succes!', 'success', 1000);
                    this.formData = { Nume: '', Cod: '', Explicatie: '', ModulID: null, Meniu: false };
                    this.getDrepturiCustom();
                })
                .catch((error) => {
                    console.error(error);
                    notify('Datele există deja!', 'error', 1000);
                });

        },
        onCancel() {
            this.isModalVisible = false;
        },
        onClick() {
            this.isModalVisible = true;
        },
        onColumnChooserClick() {
            const dataGrid = this.$refs.dataGrid.instance;
            dataGrid.showColumnChooser();
        },
        onRefreshClick() {
            this.getDrepturiCustom();
            notify('Datele au fost actualizate cu succes!', 'success', 1000)
        },
        onRowUpdating(e: any) {
            const data = { ...e.oldData, ...e.newData };
            const id = e.key;
            e.cancel = new Promise<void>((resolve, reject) => {
                AUTH_DrepturiCustom.update(id, data)
                    .then(() => {
                        notify('Modulul a fost actualizat!', 'success', 1000);
                        this.getDrepturiCustom();
                        resolve();
                    })
                    .catch((err: any) => {
                        console.error(err);
                        notify('Eroare la salvare!', 'error', 2000);
                        reject();
                    });
            });
        },
        onRowRemoving(e: any) {
            const id = e.key ?? e.data?.id;
            e.cancel = new Promise((resolve) => {
                AUTH_DrepturiCustom.delete(id)
                    .then(() => { notify('Datele au fost șterse cu succes!', 'success', 2000); resolve(false); })
                    .catch(() => { notify('A apărut o eroare la ștergere!', 'error', 2000); resolve(true); });
            });
        },
        onRowInserting() {
            notify('Datele au fost adăugate cu succes!', 'success', 1000)
        },
    },
    mounted() {
        this.getDrepturiCustom();
        this.loadModules();
        this.dataGridRef = this.$refs.dataGridRef as DxDataGrid;
        loadMessages({
            "ro": {
                "Yes": "Da",
                "No": "Nu",
            }
        });
        locale('ro');
    },
});
</script>
<style scoped>
.border {
    border-radius: 8px;
}
</style>
